export default __webpack_public_path__ + "static/media/screenshot3.41736eeb.jpg";